"use strict"

import React from "react"

export default function FeatureTriangles({
  feature_list,
  timeExtractor,
  selected_timezone,
  x,
  getFillColor,
}) {
  return (
    <>
      {feature_list.map((ft, i) => {
        const xpos = x(timeExtractor.getActionTime(ft, selected_timezone))

        return <FeatureTriangle key={i} xpos={xpos} ft={ft} getFillColor={getFillColor} />
      })}
    </>
  )
}

export const FeatureTriangle = ({ xpos, ft, getFillColor }) => {
  return (
    <path
      d={`M${xpos},0 L${xpos - 5},10 L${xpos + 5},10 Z`}
      fill={getFillColor(ft)}
      stroke={"var(--lanzalake-blue-primary)"}
    />
  )
}
